import Vue from 'vue';
import Vuex from 'vuex';

import UserStore from './user-store';
import InteractStore from './interact-store';
import RaceStore from './races-store';
import LeaugesStore from './leagues-store';
import LoadingStore from './loading-store';

// Modules
import IMSStorage from '@/modules/storage/storage';
import Brands from '@/modules/brand/brand';

import AppConfig from '../AppConfig';

const storage = new IMSStorage(AppConfig.storageKey);

Vue.use(Vuex);

declare const window: any;

export default new Vuex.Store({
  state: {
    online: true,
    brand: Brands.get(
      window.location.href.search('firestone') > -1
        ? 'firestone.indycar'
        : 'indycar.com'
    ) // Get Brand from URL
  },
  mutations: {
    online(state: any, isOnline: boolean) {
      state.online = isOnline;
    }
  },
  actions: {
    'document/title'({ commit, state }, title) {
      window.document.title = `${title} | ${AppConfig.document.title}`;
    },
    'document/title/reset'() {
      window.document.title = AppConfig.document.title;
    },
    'watch/connection'(context: any) {
      window.addEventListener('online', () => {
        console.log("We're online");
        context.commit('online', true);
      });
      window.addEventListener('offline', () => {
        console.log('We are offline');
        context.commit('online', false);
      });
    }
  },
  getters: {
    storage() {
      return storage;
    },
    isStandalone(state: any) {
      // If window._bearer is present...
      return window._standalone ? true : false;
      // if (window._bearer) {
      //   // is also _standalone present?
      //   // if not, it must be indycar - other its standalone
      //   return window._standalone != null;
      // } else {
      //   // Since no window._bearer we will assume standalone
      //   return true;
      // }
    },
    isInApp(state: any) {
      return !window._standalone && window._bearer;
    }
  },
  modules: {
    user: UserStore,
    interact: InteractStore,
    races: RaceStore,
    leagues: LeaugesStore,
    loading: LoadingStore
  }
});
